module.exports = __webpack_public_path__ + "static/testimonials-bg-530bb1d01fc69a3f21305b3a7a0d71bb.jpg";